import {NgModule} from '@angular/core';
import {MatDividerModule} from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import {FuseSharedModule} from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import {GeneralNotificationsPanelComponent} from 'app/layout/components/notifications-panel/notifications-panel.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        GeneralNotificationsPanelComponent
    ],
    imports     : [
        MatDividerModule,
        MatListModule,
        MatSlideToggleModule,
        FuseSharedModule,
        TranslateModule,
        SharedModule
    ],
    exports: [
        GeneralNotificationsPanelComponent
    ]
})
export class NotificationsPanelModule
{
}
